module.exports = __webpack_public_path__ + "static/media/add_card_icon.3e801919.svg";